import type Phaser from 'phaser';
import { defaultRenderResolution, type Size } from '../desktop/display';

/**
 * Rozdzielczość RENDEROWANIA gry (Phaser `Scale.FIT` na desktopie). To ustawienie
 * czysto renderowe — odczytywane synchronicznie przy tworzeniu `Phaser.Game`, więc
 * trzymamy je w localStorage (renderer), nie w procesie main. Tryb pełny ekran/okno
 * pozostaje osobnym ustawieniem zarządzanym przez Electron (zob. displaySettings).
 */

const KEY = 'gierka:render-resolution:v1';

let game: Phaser.Game | null = null;

/** Natywna rozdzielczość ekranu (CSS px). */
export function screenSize(): Size {
  return { width: window.screen.width, height: window.screen.height };
}

export function loadRenderResolution(): Size {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const p = JSON.parse(raw) as Partial<Size>;
      if (typeof p.width === 'number' && typeof p.height === 'number' && p.width > 0 && p.height > 0) {
        return { width: p.width, height: p.height };
      }
    }
  } catch {
    // brak / niepoprawny wpis — pierwsze uruchomienie
  }
  const def = defaultRenderResolution(screenSize());
  saveRenderResolution(def);
  return def;
}

export function saveRenderResolution(size: Size): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(size));
  } catch {
    // ignore quota errors
  }
}

/** Rejestruje instancję gry, by zmiany rozdzielczości można było stosować na żywo. */
export function registerGame(g: Phaser.Game): void {
  game = g;
}

/** Zapisuje i stosuje rozdzielczość renderowania bez restartu gry. */
export function setRenderResolution(width: number, height: number): void {
  saveRenderResolution({ width, height });
  game?.scale.setGameSize(width, height);
}
